<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="insurance-fee" v-if="canViewAccounting || canViewDriver">
                    <icon name="file"></icon>
                    บันทึกการจ่ายค่าประกัน
                </b-nav-item>&nbsp
                <b-nav-item router-link to="car-fee" v-if="canViewAccounting || canViewDriver">
                    <icon name="car"></icon>
                    บันทึกค่าผ่อนรถ - ค่าผ่อนหลังคา
                </b-nav-item>&nbsp
                <b-nav-item router-link to="deposit">
                    <icon name="credit-card"></icon>
                    บันทึกเงินฝาก
                </b-nav-item>&nbsp
                <b-nav-item router-link to="cost-repair">
                    <icon name="wrench"></icon>
                    บันทึกการจ่ายค่าซ่อม
                </b-nav-item>&nbsp
                <b-nav-item router-link to="cost-damages" v-if="canViewAccounting || canViewDriver">
                    <icon name="list-alt"></icon>
                    บันทึกค่าเสียหาย
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    import {
        canUser,
        canViewPurchases,
        canViewAccounting,
        canViewDriver,
        canViewDriverAll,
    } from "../../util/Permissions";
    export default {
        name: "account-transport-layout",
        computed:{
            canUser,
            canViewPurchases,
            canViewAccounting,
            canViewDriver,
            canViewDriverAll,
        }
    }
</script>

<style scoped>

</style>
